import moment from 'moment';
import { formats } from '../../../config/constants';
import modelBaseV2 from '../../model-base-v2.model';

const ExcelMultiChannels = {
  downloadExcelTemplate: (fileName = 'RegistrationExcelMultiTemplate') => {
    const exportConfig = {
      storedProcedureCode: '30',
      params: [],
      excelSheetNames: ['RegistrationExcelMulti'],
    };
    return modelBaseV2.postDownload('/api/executesp/export/file', { body: exportConfig }, fileName);
  },
  uploadExcel: (file) => {
    let body = new FormData();
    body.append('excel', file);

    const indexOfExtension = file.name.lastIndexOf('.');
    let filename = file.name;
    filename = filename.substring(0, indexOfExtension) + '_RESULTS' + filename.substring(indexOfExtension);

    return modelBaseV2.post('/api/datainput/registrationExcelMulti', { body }, filename);
  },
  downloadFileResult: (fileId, fileName) => {
    return modelBaseV2.getDownload(
      '/api/file/temp/:fileId',
      { params: { fileId } },
      `${fileName}_${moment().format(formats.apiDateFormat)}`
    );
  },
  getConsentInfo: () => {
    return modelBaseV2.get('/api/user/isRADealerAndConsentYN');
  }
};

export default ExcelMultiChannels;
